import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Scissors = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="scissors icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 10.5L6.94985 9.48962C6.84649 9.38715 6.70615 9.32942 6.55998 9.32942H4.7049C2.22668 9.32942 0 7.12178 0 4.66472C0 2.20765 2.22668 0 4.7049 0C7.18312 0 9.4098 2.20765 9.4098 4.66473V6.19739C9.4098 6.34036 9.46632 6.47764 9.56723 6.57977L10.7508 7.76896C10.7785 7.79694 8 10.5 8 10.5ZM6.5601 4.62171C6.5601 5.63747 5.72956 6.4609 4.70503 6.4609C3.6805 6.4609 2.84995 5.63747 2.84995 4.62171C2.84995 3.60594 3.6805 2.78251 4.70503 2.78251C5.72956 2.78251 6.5601 3.60594 6.5601 4.62171ZM6.55997 14.6707C6.70615 14.6707 6.84633 14.6132 6.94969 14.5107L18.3893 3.16897C19.6227 1.94616 20.8611 1.72004 21.9072 1.88888C22.7385 2.02305 23.4749 2.41261 24 2.81297L9.56723 17.4203C9.46632 17.5225 9.4098 17.6597 9.4098 17.8027V19.3354C9.4098 21.7924 7.18312 24 4.7049 24C2.22668 24 0 21.7924 0 19.3354C0 16.8784 2.22667 14.6707 4.7049 14.6707H6.55997ZM4.70503 21.1743C5.72956 21.1743 6.5601 20.3509 6.5601 19.3351C6.5601 18.3193 5.72956 17.4959 4.70503 17.4959C3.6805 17.4959 2.84995 18.3193 2.84995 19.3351C2.84995 20.3509 3.6805 21.1743 4.70503 21.1743ZM16.5 13.5L23.9999 21.1874C23.4748 21.5877 22.7384 21.9773 21.9071 22.1115C20.861 22.2803 19.6226 22.0542 18.3892 20.8314L13.8256 16.2353L16.5 13.5Z"
    />
  </svg>
)
